import React from 'react';
import {View, TextStyle, ViewStyle, StyleSheet} from 'react-native';
import {colors} from 'theme/Colors';
import {corner_radius} from 'theme/Units';
import {UserStoryStatus} from 'constants/enums';
import {mergeDeepRight} from 'ramda';
import {Text} from 'ui-kits';
const userStoryStatusLabel = Object.values(UserStoryStatus);

type statusVariants = (typeof userStoryStatusLabel)[number];

const variants: Record<statusVariants, Partial<baseStyleProp>> = {
  New: {
    button: {
      backgroundColor: colors.palette.greenSuccessLight,
      borderColor: colors.palette.greenSuccess,
    },
    text: {color: colors.palette.greenSuccess},
  },
  Completed: {
    button: {
      backgroundColor: colors.palette.blueInfoLight,
      borderColor: colors.palette.blueInfo,
    },
    text: {color: colors.palette.blueInfo},
  },
  'In progress': {
    button: {
      backgroundColor: colors.palette.yellowWarningLight,
      borderColor: colors.palette.yelloWarning,
    },
    text: {color: colors.palette.yelloWarning},
  },
};
type propType = Readonly<{
  variant?: statusVariants;
  text?: string;
  style?: ViewStyle;
  textStyle?: TextStyle;
}>;

export function UserStoryTag(props: propType) {
  const {
    variant = 'New',
    style: styleOverride,
    textStyle: textStyleOverride,
  } = props;

  const styles = mergeDeepRight(BASE, variants[variant]) as baseStyleProp;
  return (
    <View style={[styles.button, styleOverride]}>
      <Text style={[styles.text, textStyleOverride]}>{variant}</Text>
    </View>
  );
}

type baseStyleProp = {
  button: ViewStyle;
  text: TextStyle;
};

const BASE: baseStyleProp = StyleSheet.create({
  button: {
    maxHeight: 32,
    borderRadius: corner_radius['rounded-sm'],
    width: 104,
    borderWidth: 1.5,
    justifyContent: 'center',
    alignItems: 'center',
    paddingVertical: 4,
  },
  text: {
    fontSize: 16,
    fontWeight: '500',
  },
});
